module.exports = __webpack_public_path__ + "img/92.8.TSS.6f53608d.png";